import _isEmpty from 'lodash/isEmpty';
import { getSearchTerm } from '../analytics/analytics.helper';
import { getURLParameterBykey, isBrandPage, getPageURL } from '../utils';

/* istanbul ignore next */
export const matchMediaQuery = (query) => !__SERVER__ && window && window.matchMedia(query).matches;

// istanbul ignore next
export const exposeSkuSwatches = (galleryData) => {
    const { organicZoneInfo: { products } = {} } = galleryData;

    window.getSkuSwatches = function getSkuSwatches() {
        let skuSwatches = [];
        if (!_isEmpty(products)) {
            skuSwatches = products.map(({ ppId, skuSwatch }) => ({ ppId, skuSwatch }));
        }
        return skuSwatches;
    };
};

/* istanbul ignore next */
export const hasBreadCrumbLinks = (
    breadCrumbInfo,
    { isBot = false },
    hideBreadCrumbsWhenNoNavigation
) => {
    return !_isEmpty(breadCrumbInfo) && (isBot || !hideBreadCrumbsWhenNoNavigation)
        ? true
        : !_isEmpty(breadCrumbInfo) &&
              breadCrumbInfo.some((el) => {
                  return el.navigationState && el.navigationState.length > 0;
              });
};

export const exposeEnsembleData = (galleryData) => {
    const { organicZoneInfo: { products = [] } = {} } = galleryData;

    window.getEnsembleData = function getEnsembleData() {
        let ensembleData = [];
        if (!_isEmpty(products)) {
            ensembleData = products
                .filter(({ entityType = [] }) => entityType.includes('ENSEMBLE'))
                .map((product) => ({
                    name: product.name,
                    ppId: product.ppId,
                    priceRange: {
                        currentMin: product.currentMin,
                        currentMax: product.currentMax,
                        originalMin: product.originalMin,
                        originalMax: product.originalMax,
                    },
                    imagesInfo: product.imagesInfo,
                    bundleIndicator: product.bundleIndicator,
                    ensembleImageUrls: product.ensembleImageUrls,
                    upperLeftBadge: product.upperLeftBadge,
                }));
        }
        return ensembleData;
    };
};

export const getMappedStyliticsURL = (catId, requestUrl) => {
    const productionHostname = 'www.jcpenney.com';
    let queryParam = ['?id='];

    if (!__SERVER__ && window) {
        const { search = '' } = window?.location;
        queryParam = search.split(search.match(catId));
    }

    const mappedURL = productionHostname + requestUrl + queryParam[0] + catId;
    return mappedURL;
};

export const getProductColorwayIDs = (products) => {
    const colorwayIDs = [];
    const parseName = (name) => {
        return name.toLowerCase().replace(/ /g, '-');
    };

    products.forEach((product) => {
        const { productList } = product;

        productList?.forEach((item) => {
            const { ppId, skuSwatch } = item;

            if (ppId) {
                const colorway = skuSwatch && parseName(skuSwatch[0]?.colorName);
                const remoteId = `${ppId}_${colorway}`;

                colorwayIDs.push(remoteId);
            }
        });
    });

    return colorwayIDs.join(',');
};

export const getMultipleThumbnailsPpIds = (products) => {
    const splitPPIds = [];
    const ppIdMap = new Map();
    for (const product of products) {
        const { ppId } = product;
        if (ppIdMap.has(ppId) && !splitPPIds.includes(ppId)) {
            splitPPIds.push(ppId);
        } else {
            ppIdMap.set(ppId, 1);
        }
    }
    return splitPPIds;
};

// istanbul ignore next
const galleryVerticalImageLookup = () => {
    let lookupValue = '';
    const idExists = getURLParameterBykey('id');
    if (idExists) {
        lookupValue = idExists;
    } else if (isBrandPage()) {
        lookupValue = getPageURL()?.split('&')?.[0];
    }

    return lookupValue;
};

export const showVerticalProductImages = (
    enableVerticalProductImages,
    verticalProductImageInclusionList = { Search: [], Gallery: [] },
    pageType,
    seoTags
) => {
    let enable = false;
    if (!enableVerticalProductImages || !pageType) return enable;
    const isSearchPage = pageType === 'Search';
    const inclusionList = isSearchPage
        ? verticalProductImageInclusionList.Search
        : verticalProductImageInclusionList.Gallery;

    if (inclusionList.length > 0) {
        const lookupValue = isSearchPage ? getSearchTerm(seoTags) : galleryVerticalImageLookup();
        if (lookupValue?.length && inclusionList.includes(lookupValue)) enable = true;
    }
    return enable;
};
